// Add your custom JS here.

	(function ($) {
	  var lastScrollTop = 0,
	    delta = 90;
	  $(window).scroll(function () {
	    var nowScrollTop = $(this).scrollTop();
	    if (Math.abs(lastScrollTop - nowScrollTop) >= delta) {
	      if (nowScrollTop > lastScrollTop) {
	        $("#wrapper-navbar").addClass("scrolled-down");
	        $("#wrapper-navbar").removeClass("scrolled-up");
	      } else {
	        $("#wrapper-navbar").addClass("scrolled-up");
	        $("#wrapper-navbar").removeClass("scrolled-down");
	      }
	      lastScrollTop = nowScrollTop;
	    }
	  });
	  $(window).on("resize scroll", function () {
	    if ($(window).scrollTop() < 90) {
	      $("#wrapper-navbar").removeClass("scrolled-up");
	    }
	  });

	   $('.carousel-home').slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 5000,
          arrows: true,
          dots: true,
          pauseOnFocus: false,
          pauseOnHover: false,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                dots: true
              }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
          ]
        });


	  $('.news__carousel').slick({
	    dots: false,
	    infinite: false,
	    slidesToShow: 2,
	    slidesToScroll: 1,
	    variableWidth: true,
	    arrows: true,
	    touchThreshold:100,
	    responsive: [{
	      breakpoint: 992,
	      settings: {
	        infinite: false,
	        slidesToShow: 1,
	        slidesToScroll: 1,
	        variableWidth: true,
	        dots: false,
	        touchThreshold:100,
	        arrows: false,
	      }
	    }]
	  });

	  $('.customer-carousel').slick({
	    speed: 5000,
	    autoplay: true,
	    autoplaySpeed: 0,
	    centerMode: true,
	    cssEase: 'linear',
	    slidesToShow: 1,
	    slidesToScroll: 1,
	    variableWidth: true,
	    infinite: true,
	    initialSlide: 1,
	    arrows: false,
	    buttons: false,
	    responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                variableWidth: true,
                touchThreshold:100	
              }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
          ]
	  });


	})(jQuery);